module.exports = __webpack_public_path__ + "img/logo-icad-2.2549e06f.svg";